import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/boost/mobArrow@2x.png")